import types from './types'

const set = documentData => ({
  type: types.SET_DOCUMENT_DATA, documentData
})

const reset = documentData => ({
  type: types.RESET_DOCUMENT_DATA, documentData
})

const setMoveSelectedDocuments = moveSelectedDocuments => ({
  type: types.SET_MOVE_SELECTED_DOCUMENTS_DATA, moveSelectedDocuments
})

export default {
  set,
  reset,
  setMoveSelectedDocuments
}
